export default "__VITE_ASSET__DdXfS8ZO__"